import { Component, Input } from '@angular/core';
import { EverythingSearchResult } from '../../model/everything-search-result';
import { Source } from '../../model/search-constants';
import { UniversityLearningPathUrlPipe } from '../../pipe/university-learning-path-url.pipe';
import { EllipsisComponent } from '../../utils/ellipsis/ellipsis.component';
import { SearchResultCardComponent } from '../search-result-card/search-result-card.component';

@Component({
  selector: 'app-search-result-video',
  templateUrl: './search-result-video.component.html',
  styleUrls: [ './search-result-video.component.scss' ],
  imports: [ SearchResultCardComponent, EllipsisComponent, UniversityLearningPathUrlPipe ]
})
export class SearchResultVideoComponent {
  @Input() result: EverythingSearchResult;

  readonly placeholder = 'assets/placeholder_3x2.jpg';

  Source = Source;
}
